import ArticleFixeForm from './ArticleFixeForm'

export default ArticleFixeForm
